// Exports all env variables by default.
// This is a good place to add other global variables.

export default {
  ...process.env,
};
